export class PickBonusEvents {
    public static readonly PICK: symbol = Symbol('PICK');
    public static readonly STARTED: symbol = Symbol('STARTED');
    public static readonly FINISHED: symbol = Symbol('FINISHED');
}
